import axios from 'axios';

import { notifType, notify } from 'utils/notifSender';
import { getAuthToken } from 'utils/helpers';

import { AUTH_API_URL } from 'config/constants';

/**
 * get products
 */

export async function getProducts(cat) {
    const options = {
        method: 'GET',
        url:
            AUTH_API_URL + ((cat !== null && cat !== undefined) ? `/products${cat}&paginate=true&channel=samsung&limit=12` : '/products?paginate=true&channel=samsung&limit=12')
    };

    if (getAuthToken()) {
        options.headers = {
            Authorization: 'Bearer ' + getAuthToken()
        };
    }

    try {
        const { data } = await axios(options);

        return data;
    } catch (err) {
        notify('Something went wrong. Please try again.', notifType.DANGER);

        return false;
    }
}

/**
 * get autocomplete products
 */

export async function getAutocompleteProducts(query) {
    const options = {
        method: 'GET',
        url: AUTH_API_URL + ((query === '' || query === undefined) ? '/products?autocomplete=true&channel=samsung' : `/products?search=${query}&autocomplete=true&channel=samsung`)
    };

    try {
        const { data } = await axios(options);

        return data;
    } catch (err) {
        notify('Something went wrong. Please try again.', notifType.DANGER);

        return false;
    }
}

/**
 * get products by category
 */

export async function getProductsByCategory(categ) {
    const options = {
        method: 'GET',
        url: AUTH_API_URL + `/products?paginate=true&channel=samsung&category=${categ}&limit=4`
    };

    try {
        const { data } = await axios(options);

        return data;
    } catch (err) {
        notify('Something went wrong. Please try again.', notifType.DANGER);

        return false;
    }
}

/**
 * return product
 * @param {Object} params
 */

export async function returnProduct(params) {
    const options = {
        method: 'POST',
        params,
        url: AUTH_API_URL + '/products/return',
        headers: {
            Authorization: 'Bearer ' + getAuthToken()
        }
    };

    try {
        const { data } = await axios(options);

        return data;
    } catch (err) {
        notify('Something went wrong. Please try again.', notifType.DANGER);

        return false;
    }
}

/**
 * return product
 * @param {Object} params
 */

export async function contactProduct(params) {
    const options = {
        method: 'POST',
        params,
        url: AUTH_API_URL + '/products/contact',
        headers: {
            Authorization: 'Bearer ' + getAuthToken()
        }
    };

    try {
        const { data } = await axios(options);

        return data;
    } catch (err) {
        notify('Something went wrong. Please try again.', notifType.DANGER);

        return false;
    }
}

/**
 * return product of one category
 * @param {number} id
 */

export async function categoryProducts(id) {
    const options = {
        method: 'GET',
        url: AUTH_API_URL + '/products?channel=samsung&category[]=' + id
    };

    try {
        const { data } = await axios(options);

        return data;
    } catch (err) {
        notify('Something went wrong. Please try again.', notifType.DANGER);

        return false;
    }
}

/**
 * get samsung products
 */

export async function getSamsungProducts() {
    const options = {
        method: 'GET',
        url:
            AUTH_API_URL + '/products?channel=samsung'
    };

    if (getAuthToken()) {
        options.headers = {
            Authorization: 'Bearer ' + getAuthToken()
        };
    }

    try {
        const { data } = await axios(options);

        return data;
    } catch (err) {
        notify('Something went wrong. Please try again.', notifType.DANGER);

        return false;
    }
}
